<template>
    <basic-layout>
        <v-main>
            <v-form @submit.prevent="handleRegister" v-if="success">
                <v-container>
                    <v-layout wrap>
                        <v-flex xs12 xl10 offset-xl2>
                            <h1>Complete Registration</h1>
                            <p>Please use the form below to complete your registration.</p>
                            <p class="subheading warning--text">All fields are required</p>
                        </v-flex>
                        <v-flex xs12 sm6 xl4 offset-xl2>
                            <app-input
                                data-testid="register-user-email-input"
                                class="register-user-email-input"
                                v-model.trim="userInfo.email"
                                filled
                                label="Email"
                                :rules="{ required:true, email: true }"
                                disabled
                            >
                              Email
                            </app-input>
                        </v-flex>
                        <v-flex xs12 sm6 xl4>
                            <app-input
                                data-testid="register-user-username-input"
                                class="register-user-username-input"
                                v-model.trim="userInfo.username"
                                filled
                                :rules="{ required: true }"
                                label="Username"
                            >
                              Username
                            </app-input>
                        </v-flex>
                        <v-flex xs12 sm6 xl4 offset-xl2>
                            <app-input
                                data-testid="register-user-first-name-input"
                                class="register-user-first-name-input"
                                v-model.trim="userInfo.firstName"
                                filled
                                required
                                :rules="{ required: true }"
                                label="First Name"
                            >
                              First Name
                            </app-input>
                        </v-flex>
                        <v-flex xs12 sm6 xl4>
                            <app-input
                                data-testid="register-user-last-name-input"
                                class="register-user-last-name-input"
                                v-model.trim="userInfo.lastName"
                                filled
                                :rules="{ required: true }"
                                label="Last Name"
                            >
                              Last Name
                            </app-input>
                        </v-flex>
                        <v-flex xs12 sm6 xl4 offset-xl2>
                            <app-input
                                data-testid="register-user-password-input"
                                class="register-user-password-input"
                                v-model.trim="userInfo.password"
                                filled
                                :rules="{ required: true, password: true }"
                                label="Password"
                                type="password"
                                hint="Password must contain at least 8 characters, including one number and one special character"
                            >
                              Password
                            </app-input>
                        </v-flex>
                        <v-flex xs12 sm6 xl4>
                            <app-input
                                data-testid="register-user-confirm-password-input"
                                class="register-user-confirm-password-input"
                                v-model.trim="userInfo.passwordConfirm"
                                filled
                                :rules="{ required: true, password: true }"
                                label="Confirm Password"
                                type="password"
                            >
                              Confirm Password
                            </app-input>
                        </v-flex>
                        <v-flex xs12 xl10 offset-xl2>
                            <v-btn
                                data-testid="register-user-btn"
                                class="register-user-btn ml-0"
                                color="primary"
                                type="submit"
                            >
                                Register
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
            <v-container v-if="error">
                <h1>Uh oh! Something went wrong :(</h1>
                <p>Something went wrong while validating your registration token. Either we couldn't find a user with
                    that registration token, or your account has not been granted access to this application. Your
                    token may have expired, or the token may be invalid. Please contact support for assistance.</p>
            </v-container>
        </v-main>
    </basic-layout>
</template>

<script>
import { inputRules, passwordRules } from "@/helpers/form-rules";
import BasicLayout from "@/layouts/BasicLayout";

export default {
  data() {
    return {
      error: null,
      success: null,
      userInfo: {
        email: "",
        username: "",
        password: "",
        passwordConfirm: "",
        firstName: "",
        lastName: ""
      },
      inputRules: inputRules,
      passwordRules: passwordRules
    };
  },

  components: {
    BasicLayout
  },

  created() {
    this.$store.dispatch("validateUserRegistrationToken", this.$route.params.token)
      .then(resp => {
        this.userInfo.email = resp.user.email;
        this.success = true;
      })
      .catch(() => {
        this.error = true;
      });
  },

  methods: {
    handleRegister() {
      const payload = {
        email: this.userInfo.email,
        username: this.userInfo.username,
        password: this.userInfo.password,
        password_confirmation: this.userInfo.passwordConfirm,
        firstName: this.userInfo.firstName,
        lastName: this.userInfo.lastName,
        token: this.$route.params.token
      };

      this.$store.dispatch("registerUser", payload)
        .then(() => {
          this.$router.push({ name: "login" }).catch(() => {});
        });
    }
  },

  computed: {
    passwordMatch() {
      const rules = [];
      if (this.userInfo.password) {
        let rule = v => (!!v && v) === this.userInfo.password || "Passwords must match";
        rules.push(rule);
      }
      return rules;
    }
  }
};
</script>
